var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5801 19.2496C15.1701 19.2496 14.8301 18.9096 14.8301 18.4996V14.5996C14.8301 14.1896 15.1701 13.8496 15.5801 13.8496C15.9901 13.8496 16.3301 14.1896 16.3301 14.5996V18.4996C16.3301 18.9096 15.9901 19.2496 15.5801 19.2496Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5801 8.2C15.1701 8.2 14.8301 7.86 14.8301 7.45V5.5C14.8301 5.09 15.1701 4.75 15.5801 4.75C15.9901 4.75 16.3301 5.09 16.3301 5.5V7.45C16.3301 7.86 15.9901 8.2 15.5801 8.2Z",
    fill: "#FB4764"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41992 19.2508C8.00992 19.2508 7.66992 18.9108 7.66992 18.5008V16.5508C7.66992 16.1408 8.00992 15.8008 8.41992 15.8008C8.82992 15.8008 9.16992 16.1408 9.16992 16.5508V18.5008C9.16992 18.9108 8.83992 19.2508 8.41992 19.2508Z",
    fill: "#FB4764"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41992 10.15C8.00992 10.15 7.66992 9.81 7.66992 9.4V5.5C7.66992 5.09 8.00992 4.75 8.41992 4.75C8.82992 4.75 9.16992 5.09 9.16992 5.5V9.4C9.16992 9.81 8.83992 10.15 8.41992 10.15Z",
    fill: "#FB4764"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5801 7.33008C14.0801 7.33008 12.8501 8.55008 12.8501 10.0501C12.8501 11.5501 14.0701 12.7801 15.5801 12.7801C17.0801 12.7801 18.3001 11.5601 18.3001 10.0501C18.3001 8.54008 17.0801 7.33008 15.5801 7.33008Z",
    fill: "#FB4764"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4202 11.2305C6.9202 11.2305 5.7002 12.4505 5.7002 13.9605C5.7002 15.4705 6.9202 16.6805 8.4202 16.6805C9.9202 16.6805 11.1502 15.4605 11.1502 13.9605C11.1502 12.4605 9.9302 11.2305 8.4202 11.2305Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6f877780ea1efd3da988ed6389505fea.svg";
export { ForwardRef as ReactComponent };